module.exports = __webpack_public_path__ + "img/img14.a3cb60d7.svg";